export const transformDobForm = (
  form: Record<string, any>
): Record<string, any> => {
  if (!form.dob) return form;

  const { dob, ...rest } = form;
  return { ...rest, date_of_birth: dob };
};
